export const GET_STARTED = '01'
export const GET_STARTED_COPY = 'Get Started'
export const CONTACT_US_COPY = 'Contact Us'
export const HERO = {
  image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/hero-lifestyle.jpeg',
  title: 'Complimentary Art Advisory',
  description: 'Speak with a curator to find one-of-a-kind artworks specially chosen for you.',
}
export const SERVICES_AND_BENEFITS = {
  image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/why-saatchi.jpeg',
  title: 'Services & Benefits',
  items: [
    {
      subhead: 'Unlimited, Personalized Art Recommendations',
      description: 'Your art advisor will select works tailored to your needs with no limitations.',
    },
    {
      subhead: 'Manage Artist Communications',
      description:
        'Your advisor handles all artist communications, ensuring fair agreements and positive relations.',
    },
    {
      subhead: 'Exceptional Customer Service',
      description:
        'Enjoy hands-on customer service from your curator and dedicated operations representative.',
    },
    {
      subhead: 'Hassle-Free Shipping',
      description:
        'All shipments are insured for hassle-free shipping, with safe delivery and smooth communication.',
    },
  ],
}
export const TEAM = [
  {
    name: 'Erin Remington',
    title: 'Curatorial Director',
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/curators/erin-remington-2025-360x360.jpg',
    collectionUrl: '/account/collection/1586325',
  },
  {
    name: 'India Balyejusa',
    title: 'Senior Curator',
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/curators/india-balyejusa-2025-360x360.jpg',
    collectionUrl: '/account/collection/1754780',
  },
  {
    name: 'Will Hardy',
    title: 'Assistant Curator',
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/curators/will-hardy-2025-360x360.jpg',
    collectionUrl: '/account/collection/2520929',
  },
  {
    name: 'Siting Wang',
    title: 'Associate Curator',
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/curators/siting-wang-2025-360x360.jpg',
    collectionUrl: '/account/collection/1861756',
  },
  {
    name: 'Audrey Wolfe',
    title: 'Assistant Curator',
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/curators/audrey-wolfe-2025-360x360.jpg',
    collectionUrl: '/account/collection/2131451',
  },
]

export const REVIEWS_CAROUSEL = [
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/carousel-image-1.jpg',
    title: 'Very Responsive and Knowledgeable',
    description:
      'The curator with whom I have worked has been very responsive and knowledgeable. I will definitely use Saatchi Art in the future for any art needs.',
    name: '-Miriam M.',
    artworkTitle: 'Into the Mystic Painting by Vernon Studio',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/carousel-image-2.jpg',
    title: 'The Team and the Process Are Great!',
    description: `The curation team is knowledgeable and supportive. The process is quite seamless and brings together a novice collector with exceptional talent couldn’t have been easier.`,
    name: '-Doug G.',
    artworkTitle: 'Poetry of Light Painting by Heidi Thompson',
  },
  {
    image: '//d3t95n9c6zzriw.cloudfront.net/art-advisory/carousel-image-3.jpg',
    title: `It's Great To Get Recommendations From Someone...`,
    description: `It's great to to be able to get recommendations from someone so familiar with emerging Asian artists.`,
    name: '-Huyan Jee S',
    artworkTitle: 'Image-Face (Model) Painting by GyoBeom An',
  },
]
